export default __webpack_public_path__ + "static/media/Logo-cto.163c7c0c.svg";